export var SDK_VERSION = '4.21.8';
//# sourceMappingURL=version.js.map